import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { injectedLocalApi } from '@/services/local'

type PlainInfo<T> = {
  status: RequestState
  error?: string | null
  data: T
}

type RequestState = 'pending' | 'fulfilled' | 'rejected' | 'none'

interface ThankyouState {
  checkoutResults: PlainInfo<Oms.StoreOrderAndPaymentStatus>
  validateTokenResults: PlainInfo<Record<string, unknown>>
  trackingDeliveryResults: PlainInfo<{
    trackingLink?: string
    etaToCustomer?: number
  }>
}

const initialState: ThankyouState = {
  checkoutResults: {
    status: 'none',
    error: null,
    data: {} as Oms.StoreOrderAndPaymentStatus,
  },
  validateTokenResults: {
    status: 'none',
    data: {},
    error: null,
  },
  trackingDeliveryResults: {
    status: 'none',
    data: {},
    error: null,
  },
}

export const thankyouSlice = createSlice({
  name: '@thankyou',
  initialState,
  reducers: {
    setDefaultCheckoutResults: (
      state,
      action: PayloadAction<Oms.ApiResponse<Oms.StoreOrderAndPaymentStatus>>
    ) => {
      state.checkoutResults.data = action.payload.payload
      state.checkoutResults.error = action?.payload?.errorMessage
      state.checkoutResults.status = !action?.payload?.errorMessage
        ? 'fulfilled'
        : 'rejected'
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      injectedLocalApi.endpoints.getStoreOrderPaymentStatus.matchFulfilled,
      (state, action) => {
        state.checkoutResults.status = 'fulfilled'
        state.checkoutResults.data = action.payload.data.payload
      }
    )
  },
})

export const { setDefaultCheckoutResults } = thankyouSlice.actions
